<template>
	<div class="w1200 flex myinfo">
		<choice-menu></choice-menu>
		<div class="flex flex-direction align-stretch benben-flex-layout myinfo_1">
			<div class="flex bind_1">
				<div class="flex benben-flex-layout flex-wrap align-center pointer " @click="caozuo(1)">
					<img class="bind_1_1" src="https://api.ezlunch.club/pc/image/13.png" alt="" srcset="">
					<div class="bind_1_2">{{$t('返回')}}</div>
				</div>
			</div>
			<div class="flex flex-direction align-stretch benben-flex-layout" v-loading="loading"  :element-loading-text="$t('拼命加载中')">
				<div class="orderDetal_1"></div>
				
				<div class="flex orderDetal_2">
					<div class="orderDetal_2_1 flex-sub">{{$t('配送日期')}}：{{details.date}}</div>
					<div class="orderDetal_2_2" v-if=" details.status=='sending'">{{$t('待配送')}}</div>
					<div class="orderDetal_2_2" v-if=" details.status=='delivery'">{{$t('配送中')}}</div>
					<div class="orderDetal_2_1" v-if=" details.status=='finish'">{{$t('已完成')}}</div>
					<div class="orderDetal_2_1" v-if=" details.status=='cancel'">{{$t('已取消')}}</div>
				</div>
				<div class="orderDetal_1s">{{$t('收货地址')}}</div>
				<div class="flex orderDetal_3" v-if="details.address_info">
					<img class="orderDetal_3_4" src="https://api.ezlunch.club/pc/image/32.png" alt="" srcset="">
					<div class="flex-sub">
						<div class="flex benben-flex-layout flex-wrap align-center orderDetal_3_1">
							<div>{{details.address_info.real_name}}</div>
							<div class="orderDetal_3_2">{{details.address_info.mobile}}</div>
						</div>
						<div class="orderDetal_3_3">{{details.address_info.address}}{{details.address_info.detail}}</div>
					</div>
				</div> 
				<div class="flex benben-flex-layout flex-wrap align-center orderDetal_4">
					<div class="orderDetal_4_1">{{$t('预约套餐')}}</div>
					<img class="orderDetal_4_2" src="https://api.ezlunch.club/pc/image/33.png" alt="" srcset="">
					<div class="orderDetal_4_3" v-if=" details.meal_ticket_two>0">{{$t('两菜饭票')}}x{{details.meal_ticket_two}}</div>
					<div class="orderDetal_4_3" v-if=" details.meal_ticket_three>0">{{$t('三菜饭票')}}x{{details.meal_ticket_three}}</div>
					<!-- <div class="orderDetal_4_4">{{$t('已退回')}}</div> -->
					
				</div>
				<div class="orderDetal_5">
					<template v-for="(item,index) in details.child">
						<div class="flex appointment_4">
							<img class="appointment_4_1" :src='item.thumb' alt="" srcset="">
							<div class="flex-sub flex flex-direction align-stretch justify-between benben-flex-layout appointment_4_2">
								<div class="appointment_4_3">{{item.name}}</div>
								<div class="appointment_4_4">{{item.num}}{{$t('份')}}</div>
							</div>
						</div>
					</template>
					
				</div>
				<div class="flex orderDetal_2s" v-if="details.remark">
					<div class="orderDetal_2_1s">{{$t('备注')}}：</div>
					<div class="orderDetal_2_1ss flex-sub">{{details.remark}}</div>
				</div>
				<div class="flex benben-flex-layout flex-wrap align-center orderDetal_4">
					<div class="orderDetal_4_1">{{$t('订单信息')}}</div>
				</div>
				<div class="flex orderDetal_6">
					<div class="flex benben-flex-layout flex-wrap align-center orderDetal_6_1">
						<div>{{$t('订单编号')}}</div>
						<div class="orderDetal_6_2">{{details.order_sn}}</div>
					</div>
					<div class="flex benben-flex-layout flex-wrap align-center orderDetal_6_1">
						<div>{{$t('下单时间')}}</div>
						<div class="orderDetal_6_2">{{details.create_time}}</div>
					</div>
				</div>
				<div class="flex flex-wrap align-center justify-end benben-flex-layout orderDetal_9">
					<div class="orderDetal_8 pointer"  v-if="details.is_cancel_can==1" @click="visible1 = true">{{$t('取消订单')}}</div>
					<div class="orderDetal_7 pointer" @click="caozuo(2)">{{$t('联系客服')}}</div>
				</div>
			</div>
		</div>
		
		<el-dialog class="footer_6" title="" :visible.sync="visible1" width="460px" >
			<div class="choiceFood_9">
				<div class="flex align-center justify-between benben-flex-layout choiceFood_9_1">
					<div class="choiceFood_9_2">{{$t('温馨提示')}}</div>
				</div>
				<div class="fflex flex-direction align-stretch benben-flex-layout choiceFood_17" >
					<div class="choiceFood_15">{{$t('确定要取消订单吗？取消后，订单饭票将退回')}}</div>
					<div class="flex choiceFood_16">
						<div class="choiceFood_16_1 pointer" @click="visible1 = false">{{$t('稍后再说')}}</div>
						<div class="choiceFood_16_2 pointer" @click="post68e779ab8465c">{{$t('确认取消')}}</div>
					</div>
				</div>
			</div>
		</el-dialog>
		
	</div>
</template>

<script>
	import ChoiceMenu from "../components/choiceMenu.vue"
	export default {
		components: {
			ChoiceMenu
		},
		data() {
			return {
				details:'',
				order_id:'',
				visible1:false,
				post_type:false,
				loading:true,
			}
		},
		created() {
			if(window.sessionStorage.getItem('token')){
				if(window.sessionStorage.getItem('order_id')){
					this.order_id = window.sessionStorage.getItem('order_id')
					// window.sessionStorage.setItem('order_id','');
					this.post68d91e207c067()
				}
			}else{
				this.$router.push({
					name: 'login',
				});
			}
		},

		methods: {
			gengxin(){
				this.loading = true
				this.post68d91e207c067()
			},
			//取消订单-套餐订单
			post68e779ab8465c(){
				if(this.post_type){
					return
				}
				this.post_type = true
				this.$api.post(this.$apiUrls.post68e779ab8465c,{aid: this.order_id}).then((res) => {
					if(res.code == 1){
						this.visible1 = false
						this.post68d91e207c067()
						this.post_type = false
					}else{
						this.$message.error(res.msg);
						this.post_type = false
						return
					}
				})
			},
			post68d91e207c067(){
				this.$api.post(this.$apiUrls.post68d91e207c067,{aid: this.order_id}).then((res) => {
					if(res.code == 1){
						this.details = res.data
						this.loading = false
					}else{
						this.$message.error(res.msg);
						return
					}
				})
			},
			caozuo(type){
				let url = ''
				if(type == 1){
					// url = 'myinfo'
					window.history.back();
					return
				}else if(type == 2){
					this.$router.push({
						name: 'service',
					});
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep {
		.footer_6{
			.el-dialog__header{
				display: none;
			}
			.el-dialog__body{
				padding: 0 !important;
				border-radius: 16px 16px 16px 16px;
				// background: rgba(187,195,211,0) !important;
			}
		}
		.el-loading-mask {
			opacity: 1 !important; 
			background-color: rgba(255, 255, 255, 1) !important;
		}
	}
	.myinfo{
		margin-top: 20px;
	}
	.myinfo_1{
		width: 980px;
		margin: 0 0 0 220px;
		padding:0 20px 100px;
		background: #fff;
		box-sizing: border-box;
	}
	.bind_1{
		padding: 20px 0;
		border-bottom: 1px solid #EEEEEE;
	}
	.bind_1_1{
		width: 14px;
		height: 14px;
	}
	.bind_1_2{
		font-weight: 500;
		font-size: 14px;
		color: #666666;
		margin-left: 10px;
	}
	.orderDetal_1{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
		margin: 16px 0 0 0;
	}
	.orderDetal_1s{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
		margin: 24px 0 0 0;
	}
	.orderDetal_2s{
		// height: 52px;
		background: #F8F8FA;
		border-radius: 6px 6px 6px 6px;
		padding:16px;
		margin-top: 14px;
	}
	.orderDetal_2{
		height: 52px;
		background: #F8F8FA;
		border-radius: 6px 6px 6px 6px;
		padding: 0 16px;
	}
	.orderDetal_2_1{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		line-height: 52px;
	}
	.orderDetal_2_1s{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
	.orderDetal_2_1ss{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		word-break: break-word;
	}
	.orderDetal_2_2{
		font-weight: 400;
		font-size: 14px;
		color: #FF770F;
		line-height: 52px;
	}
	.orderDetal_3{
		background: #F8F8FA;
		border-radius: 6px 6px 6px 6px;
		padding: 14px 16px;
		margin: 16px 0 0 0;
	}
	.orderDetal_3_4{
		width: 20px;
		height: 20px;
	}
	.orderDetal_3_1{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.orderDetal_3_2{
		margin: 0 0 0 10px;
	}
	.orderDetal_3_3{
		font-weight: 400;
		font-size: 14px;
		color: #666666;
		margin: 10px 0 0 0;
	}
	.orderDetal_4{
		margin: 24px 0 0 0;
	}
	.orderDetal_4_1{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.orderDetal_4_2{
		width: 20px;
		height: 20px;
		margin: 0 0 0 10px;
	}
	.orderDetal_4_3{
		font-weight: 400;
		font-size: 14px;
		color: #8C8C8C;
	}
	.orderDetal_4_4{
		font-weight: 400;
		font-size: 14px;
		color: #FF4B4D;
		margin: 0 0 0 10px;
	}
	.orderDetal_5{
		background: #F8F8FA;
		padding: 0px 16px 16px 16px;
		margin: 16px 0 0 0 ;
		border-radius: 8px;
	}
	.appointment_4{
		margin: 16px 0 0 0;
	}
	.appointment_4_1{
		width: 96px;
		height: 96px;
	}
	.appointment_4_2{
		margin: 0 0 0 12px;
		height: 96px;
	}
	.appointment_4_3{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.appointment_4_4{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
		// margin: auto 0 0 0;
	}
	.orderDetal_6{
		margin: 16px 0 0 0;
		padding: 0 0 16px 0;
		// width: 100%;
		border-bottom: 1px solid #E7E7E7;
	}
	.orderDetal_6_1{
		// width: 50%;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin: 0 137px 0 0;
	}
	.orderDetal_6_2{
		margin-left: 10px;
	}
	.orderDetal_9{
		margin: 30px 0 0 0;
	}
	.orderDetal_7{
		height: 48px;
		background: #FF770F;
		border-radius: 8px 8px 8px 8px;
		font-weight: 400;
		font-size: 16px;
		color: #FFFFFF;
		line-height: 48px;
		padding:0 40px;
	}
	.orderDetal_8{
		height: 48px;
		border-radius: 8px 8px 8px 8px;
		font-weight: 400;
		font-size: 16px;
		color: #333333;
		line-height: 48px;
		padding:0 40px;
		border: 1px solid #CCCCCC;
		margin: 0 20px 0 0;
	}
	.choiceFood_9{
		width: 560px;
		// height: 573px;
		padding: 0 0 40px 0;
		background: #FFFFFF;
		border-radius: 8px 8px 8px 8px;
	}
	.choiceFood_9_1{
		width: 100%;
		height: 56px;
		background: #F3F3F3;
		border-radius: 8px 8px 0px 0px;
		padding: 0 20px;
	}
	.choiceFood_9_2{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.choiceFood_17{
		padding: 0 20px;
	}
	.choiceFood_15{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
		margin: 20px 0 24px 0;
	}
	.choiceFood_16_1{
		width: 100px;
		height: 36px;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #CCCCCC;
		text-align: center;
		line-height: 36px;
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin: 0 20px 0 auto;
	}
	.choiceFood_16_2{
		width: 100px;
		height: 36px;
		background: #FF770F;
		border-radius: 4px 4px 4px 4px;
		text-align: center;
		line-height: 36px;
		font-weight: 400;
		font-size: 14px;
		color: #FFFFFF;
	}
</style>